'use client'

import ChartCardLoading from '@/components/charts/components/ChartCardLoading'

/** Reserves the 400px "No position found." state, which the card turns into for a wallet with no position. */
const ChartOverviewMyBorrowLoading = () => {
  return (
    <ChartCardLoading
      className="gap-lg min-h-[400px]"
      chartClassName="h-[224px]"
      valueClassName="h-[44px] w-[170px]"
      controls={['h-8 w-[163px] md:h-8 md:w-[231px]', 'h-8 w-[103px]']}
    />
  )
}

export default ChartOverviewMyBorrowLoading
